<template>
  <div class="d-flex align-center">
    <div :style="WidthAndHeight" :class="{ 'elevation-2': dataset?.selected }"
      class="d-flex align-center mr-3 accessory-image-wrapper">
      <v-img class="accessory-image" :width="is_mobile ? 35 : 40" :src="AccessoryImage(accessory)" alt="Accessory Image" />
    </div>
    <div class="w-100">
      <span class="clip-text-2-lines accessory-name">{{ name }}</span>
    </div>
  </div>
  <div class="d-flex">
    <v-spacer />
    <slot name="actions" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const props = defineProps<{
  accessory: any
  dataset?: any
}>()

const store = useGlobalsStore()
const { is_mobile } = storeToRefs(store)

const name = computed(() => {
  return props.accessory?.name || ''
})

const WidthAndHeight = computed(() => {
  return is_mobile.value ? "width:35px;height:35px" : "width:60px;height:60px"
})

function AccessoryImage(acc: any) {
  const url = (import.meta.env.VITE_SERVERAPI_URL || '') + '/storage/uploads/accessories'
  if (acc?.featured_image && acc.featured_image.length > 0) {
    return `${url}/${acc.featured_image}`
  } else {
    return `${url}/_placeholder_.png`
  }
}
</script>

<style>
@media(min-width: 900px) {
  .accessory-name {
    min-height: 40px;
  }
}

.accessory-image-wrapper {
  height: 50px;
  background: #ffffff;
  border-radius: 15px;
}

.accessory-image-wrapper .accessory-image {
  border-radius: 15px;
}
</style>
